module.exports = __webpack_public_path__ + "static/media/FD9.ed07832c.png";